var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M511.9,80.6v-16c0-4.6-3.7-8.4-8.4-8.4H35.4c-4.6,0-8.4,3.7-8.4,8.4v16V105v24.4v24.5v24.4v24.6v16 v32.8V276v24.5V325v24.5v16c0,4.6,3.7,8.4,8.4,8.4h468.2c0.3,0,0.6,0,0.9,0c4.2-0.4,7.5-4,7.5-8.4v-16h-0.1V325h0.1v-24.4h-0.1V276 h0.1v-24.4h-0.1v-24.4h0.1v-24.4h-0.1v-24.6h0.1v-24.4h-0.1v-24.5h0.1v-24.4h-0.1V80.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M511.9,64.6c0-4.6-3.7-8.4-8.4-8.4H35.4c-4.6,0-8.4,3.7-8.4,8.4v16h484.9V64.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 153.8,
    style: {
      fill: "#FF4B55"
    },
    width: 485,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 105,
    style: {
      fill: "#FF4B55"
    },
    width: 485,
    height: 24.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M27,218.9c0,4.6,3.7,8.4,8.4,8.4H512v-24.4H27V218.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 300.5,
    style: {
      fill: "#FF4B55"
    },
    width: 485,
    height: 24.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M27,365.5c0,4.6,3.7,8.4,8.4,8.4h468.2c4.6,0,8.4-3.8,8.4-8.4v-16H27V365.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 251.6,
    style: {
      fill: "#FF4B55"
    },
    width: 485,
    height: 24.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M257.8,56H42.7c-4.7,0-8.6,3.9-8.6,8.6v158.8c0,4.7,3.8,8.6,8.6,8.6h215.1c4.7,0,8.6-3.8,8.6-8.6 V64.6C266.4,59.8,262.5,56,257.8,56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.3,75.7l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-5-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C57,75,58,75,58.3,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.3,105.6l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C57,104.8,58,104.8,58.3,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.3,135.5l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C57,134.8,58,134.8,58.3,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.3,165.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C57,164.6,58,164.6,58.3,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.3,195.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C57,194.5,58,194.5,58.3,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M81.5,90.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C80.2,89.6,81.2,89.6,81.5,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M81.5,120.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C80.2,119.5,81.2,119.5,81.5,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M81.5,150.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5L85,161l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C80.2,149.4,81.2,149.4,81.5,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M81.5,180l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C80.2,179.3,81.2,179.3,81.5,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.6,75.7l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 L99,93.1c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.9-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C103.3,75,104.4,75,104.6,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.6,105.6l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 L99,123c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C103.3,104.8,104.4,104.8,104.6,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.6,135.5l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 L99,153c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C103.3,134.8,104.4,134.8,104.6,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.6,165.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C103.3,164.6,104.4,164.6,104.6,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.6,195.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C103.3,194.5,104.4,194.5,104.6,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M127.8,90.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C126.5,89.6,127.6,89.6,127.8,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M127.8,120.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C126.5,119.5,127.6,119.5,127.8,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M127.8,150.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C126.5,149.4,127.6,149.4,127.8,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M127.8,180l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-5-3.4 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C126.5,179.3,127.6,179.3,127.8,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.1,75.7l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-5-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C149.8,75,150.8,75,151.1,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.1,105.6l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C149.8,104.8,150.8,104.8,151.1,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.1,135.5l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C149.8,134.8,150.8,134.8,151.1,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.1,165.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C149.8,164.6,150.8,164.6,151.1,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M151.1,195.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C149.8,194.5,150.8,194.5,151.1,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M174.3,90.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C173,89.6,174,89.6,174.3,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M174.3,120.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C173,119.5,174,119.5,174.3,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M174.3,150.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C173,149.4,174,149.4,174.3,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M174.3,180l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C173,179.3,174,179.3,174.3,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.4,75.7l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C196.1,75,197.2,75,197.4,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.4,105.6l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C196.1,104.8,197.2,104.8,197.4,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.4,135.5l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C196.1,134.8,197.2,134.8,197.4,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.4,165.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C196.1,164.6,197.2,164.6,197.4,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.4,195.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5L201,206l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C196.1,194.5,197.2,194.5,197.4,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.6,90.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C219.3,89.6,220.4,89.6,220.6,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.6,120.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C219.3,119.5,220.4,119.5,220.6,120.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.6,150.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C219.3,149.4,220.4,149.4,220.6,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.6,180l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C219.3,179.3,220.4,179.3,220.6,180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.8,75.7l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C242.5,75,243.5,75,243.8,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.8,105.6l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C242.5,104.8,243.5,104.8,243.8,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.8,135.5l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-5,3.6c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C242.5,134.8,243.5,134.8,243.8,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.8,165.4l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C242.5,164.6,243.5,164.6,243.8,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.8,195.2l1.9,5.7h6c0.8,0,1.1,1,0.5,1.5l-4.8,3.6l1.8,5.7c0.2,0.7-0.6,1.4-1.2,0.9l-4.9-3.5 l-4.9,3.5c-0.6,0.5-1.5-0.2-1.2-0.9l1.8-5.7l-4.8-3.6c-0.6-0.5-0.3-1.5,0.5-1.5h6l1.9-5.7C242.5,194.5,243.5,194.5,243.8,195.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E3033"
    },
    d: "M18.9,485.3L18.9,485.3C8.5,485.3,0,476.8,0,466.4v-421c0-10.3,8.4-18.7,18.7-18.7h0.2 c10.4,0,18.9,8.5,18.9,18.9v420.8C37.8,476.8,29.3,485.3,18.9,485.3z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.21b4282d682f111b15b60d9c800faa76.svg";
export { ForwardRef as ReactComponent };